import { LineOrientation } from '../models/interfaces';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ExtractedRowForm } from '../models/extraction-form-models';
import { ExtractedValue } from '../models/extracted-values';
import { TableData } from '../table-overlay/table-overlay';
import { signal } from '@angular/core';
import {
  FieldGroupModel,
  FieldModel,
  TableModel,
} from '../models/extraction-models/extraction-models';
import { ExtractionSectionViewType } from '../models/domain-extraction-specifications';
import { FieldType } from '@ps-gui/shared-utils';

export const getTestTableData = (): TableData => {
  return {
    tableModelKey: 'test-table-sections',
    confirmed: signal(false),
    layoutDefined: signal(false),
    lines: {
      vertical: signal([
        { offset: signal(0), orientation: LineOrientation.VERTICAL },
        { offset: signal(0), orientation: LineOrientation.VERTICAL },
      ]),
      horizontal: signal([
        { offset: signal(0), orientation: LineOrientation.HORIZONTAL },
        { offset: signal(0), orientation: LineOrientation.HORIZONTAL },
      ]),
    },
    columnHeaders: signal([]),
    id: '0',
    pageId: '',
  };
};

export const getDefaultTableAuditPositionRow = (): ExtractedRowForm => {
  const fb = new FormBuilder();
  return fb.group({
    rowData: fb.group({
      audit_position_description: fb.group({
        value: fb.nonNullable.control<ExtractedValue>('Beschreibung'),
        id: fb.nonNullable.control('description'),
      }),
    } as {
      [K: string]: FormGroup<{
        value: FormControl<ExtractedValue>;
        id: FormControl<string>;
      }>;
    }),
    class: fb.nonNullable.control<string | undefined>(undefined),
    rowMembership: fb.nonNullable.control({
      documentId: '',
    }),
  }) as ExtractedRowForm;
};

export const testFieldModel: FieldModel = {
  index: 0,
  key: 'test-field',
  label: { text: 'test-field-label', genus: 'M' },
  type: FieldType.STRING,
};

export const testTableModel: TableModel = {
  fieldModels: [testFieldModel],
  index: 0,
  key: '',
  label: '',
  type: 'tableModel',
};

export const testFieldGroup: FieldGroupModel = {
  key: 'test-field-group',
  label: 'test group label',
  fieldModels: [testFieldModel],
  index: 0,
  type: 'fieldGroupModel',
};

export const defaultExtractionPage = {
  sections: [testFieldGroup],
  viewType: ExtractionSectionViewType.SCROLLABLE,
};
